/**
 * Normalize integration `source` strings from the API or query for comparisons.
 * @param {string|undefined|null} source
 * @returns {string}
 */
export const normalizeIntegrationSource = (source) =>
    String(source ?? "")
        .trim()
        .toUpperCase()
        .replace(/[\s_-]/g, "");

const NOPCOMMERCE_ADMIN_ORDER_EDIT_BASE = "https://mysnacks.shop/Admin/Order/Edit";

/**
 * Build admin "edit order" URL for an external integration, if supported.
 * @param {string|undefined|null} source - Integration source (e.g. NOPCOMMERCE)
 * @param {string|number|undefined|null} adminOrderId - Id used by the remote admin (e.g. nopCommerce order id)
 * @returns {string|null} Full URL or null when unknown / missing id
 */
export const getExternalAdminOrderEditUrl = (source, adminOrderId) => {
    const key = normalizeIntegrationSource(source);
    const id =
        adminOrderId != null && String(adminOrderId).trim() !== "" ? String(adminOrderId).trim() : null;
    if (!id) return null;
    if (key === "NOPCOMMERCE") {
        return `${NOPCOMMERCE_ADMIN_ORDER_EDIT_BASE}/${encodeURIComponent(id)}`;
    }
    return null;
};
